import { render, staticRenderFns } from "./ManagementApprovalVehicle.vue?vue&type=template&id=2c16dc97&scoped=true"
import script from "./ManagementApprovalVehicle.vue?vue&type=script&lang=js"
export * from "./ManagementApprovalVehicle.vue?vue&type=script&lang=js"
import style0 from "./ManagementApprovalVehicle.vue?vue&type=style&index=0&id=2c16dc97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c16dc97",
  null
  
)

export default component.exports